import { useMemo } from "react";
import { Patient } from "../../../utils/api-objects/Patient";
import { useAuth } from "../../../utils/context/AuthContext";
import { BucketFolder } from "../../../utils/Enums";
import { useFileDropzone } from "../hooks/useFileDropzone";
import FileDropzoneBox from "./FileDropzoneBox";

interface PrivateDocumentsBoxProps {
    patient: Patient;
}

const PrivateDocumentsBox: React.FC<PrivateDocumentsBoxProps> = ({ patient }) => {
    const { auth } = useAuth();
    
    // Create the folder names as strings, memoized to prevent re-renders
    // Using a different prefix to avoid conflicts with shared documents
    const privateFolder = useMemo((): BucketFolder => {
        return `private_expert_${auth.userId}` as BucketFolder;
    }, [auth.userId]);
    
    const privateUploadFolder = useMemo((): string => {
        return `private_expert_${auth.userId}`;
    }, [auth.userId]);

    const {
        files,
        isLoading,
        error,
        uploadedFile,
        isUploading,
        onFileSelect,
        onFileRemove,
        uploadFile
    } = useFileDropzone({
        patientId: patient.user_id,
        folder: privateFolder,
        uploadFolder: privateUploadFolder
    });

    return (
        <FileDropzoneBox
            title="🔒 Documenti privati"
            description="I documenti caricati sono visibili solo a te. I pazienti non possono vedere questi documenti."
            files={files}
            isLoading={isLoading}
            error={error}
            uploadedFile={uploadedFile}
            isUploading={isUploading}
            onFileSelect={onFileSelect}
            onFileRemove={onFileRemove}
            onUpload={uploadFile}
            uploadButtonText="Carica documento"
            selectButtonText="Scegli documento"
            placeholder="Trascina qui un documento privato, oppure clicca per selezionarlo"
            showFiles={true}
        />
    );
};

export default PrivateDocumentsBox; 